import { PageType } from "shared/lib/page-type";

export const pathname = "/games/word-search";

export const page = {
  route(query: QueryParameters) {
    return { pathname, query: { ...query, pageType: PageType.GamesWordSearch } };
  },
};
